const findNode = (menuId, currentNode, parseSubMenu = true) => {
  let result;
  if (currentNode.menuId === menuId) {
    if (parseSubMenu) {
      return currentNode.subMenu;
    } else {
      return [currentNode];
    }
  } else {
    const { subMenu } = currentNode;
    if (subMenu !== undefined) {
      for (let i = 0; i < subMenu.length; i++) {
        const currentChild = subMenu[i];
        result = findNode(menuId, currentChild, parseSubMenu);
        if (result !== false) {
          return result;
        }
      }
    }
    return false;
  }
};

const findInitSideMenu = (menuName, menuLinks, menu) => {
  switch (menuName) {
    case undefined:
    case false:
    case null:
      return menuLinks;
    case 'Home':
      return false;
    default:
      return findNode(menuName, menu);
  }
};

const findContext = (slug) =>
  slug && slug
    .split("/")[1]
    .replace(/-/i, " ")
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());


/**
 * findAppendUrl function
 * 
 * This function is used for the Multiverso purpose. It gets the path that the button is redirecting to,
 * then determines whether the user is on the Multiverso environment or not, and then prepends the branch
 * path i.e. snapshots/${BRANCH_NAME} to the path so it redirects to the right URL. For the production it
 * returns the original path.
 * 
 * @param {string} href - The path where the button or the link redirects to.
 * @returns {string} The final path where the click will redirect to.
*/
const findAppendUrl = (href) => {
  let pathname = '';
  let newHref = href;
  const location = typeof window !== 'undefined' ? window.location : '';
  if (location) pathname = location.pathname.slice(0, -1);
  let pathPattern = /snapshots/;
  const found = pathname.match(pathPattern);
  if(found) newHref = `${pathname}${newHref}`;
  return newHref;
}

/**
 * shouldRedirectErrorPage function
 * 
 * In S3, which we use to deploy our application, the error page needs to be defined in the case the user tries
 * to access a page that doesnot exists. This decleration however is static which works properly for our Production
 * environment but in the Multiverso environment this doesnot work as each branch has its own error page. So, to avoid 
 * this confusion and access the correct error page for each branch we are redirecting the page to each branch's error page.
 * This function so aims to determine whether the user is on the Multiverso environment and will they need to be redirect
 * to correct error page in the case of accessing an unavailable page.
 * 
 * @return {boolean} Returns a boolean value that decides whether the redirection to error page is needed or not. 
*/
const shouldRedirectErrorPage = () => {
  let pathname = '';
  const location = typeof window !== 'undefined' ? window.location : '';
  if (location) pathname = location.pathname.slice(0, -1);
  let pathPattern = /snapshots/;
  return pathname.match(pathPattern) && !pathname.includes('404.html');
}

export { findNode, findInitSideMenu, findContext, findAppendUrl, shouldRedirectErrorPage };
